import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { AddLeadDialog } from "./campaign/Components/Dialogs";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useLocation } from "react-router-dom";

const buttonStyle = {
  marginTop: "20px",
  display: "block",
  backgroundColor: "#007FFF",
  color: "#fff",
};

const AddLead = () => {
  const [open, setOpen] = useState(false);
  const [actionsPerformed, setActionsPerformed] = useState(false);
  const expertId = useSelector((state: RootState) => state.auth.user.expertId);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("jobId") || "";
  const campaignId = params.get("campaignId") || "";

  const handleOpen = () => setOpen(true);
  
  const handleClose = () => {
    setOpen(false);
    
    setActionsPerformed(false);
  };

  const handleActionPerformed = () => {
    setActionsPerformed(true);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Button variant="contained" onClick={handleOpen} style={buttonStyle}>
        Add Leads
      </Button>
      <AddLeadDialog 
        open={open} 
        onClose={handleClose}
        expertId={expertId}
        jobId={jobId}
        campaignId={campaignId}
        onActionPerformed={handleActionPerformed}
      />
    </Box>
  );
};

export default AddLead;
